import type { ComponentDocMap } from './types'

/**
 * Prop documentation for the `container` component.
 * Keep in sync with ContainerProps in src/ui/uiConfig/components/Container/Container.tsx
 */
export const containerPropDocs: ComponentDocMap = {
  items: {
    description: 'Layout configuration for each child slot. Order in this array determines render order.',
    type: '{ child_id: string; size: number; widthPercentage?: number }[]',
    example: '[{ child_id: "42", size: 1 }, { child_id: "43", size: 2 }]',
  },
  'items[].child_id': {
    description: 'The id of the child UiConfig to place in this slot. Must match a value in children_ids.',
    type: 'string',
    example: '"42"',
  },
  'items[].size': {
    description:
      'Flex grow factor. A child with size 2 takes twice as much space as one with size 1. Use 0 to prevent growing.',
    type: 'number',
    example: '1',
  },
  'items[].widthPercentage': {
    description: 'Sets an explicit percentage width instead of relying on flex grow.',
    type: 'number',
    example: '33',
  },
  direction: {
    description: 'Sets whether children are laid out in a horizontal row or vertical column.',
    type: '"row" | "column"',
    example: '"row"',
  },
  style: {
    description: 'Apply "card" to wrap the container in a card with a shadow and padding.',
    type: '"card" | ""',
    example: '"card"',
  },
  title: {
    description: 'Optional heading shown above the container.',
    type: 'string',
    example: '"__Overview"',
  },
  margin: {
    description: 'Adds outer margin around the container.',
    type: 'boolean',
    example: 'true',
  },
}
